import { clsx } from 'clsx';
import { FC } from 'react';
import { NavigationOptions } from 'swiper/types';
import { IconSVG } from 'atoms/IconSVG';
import styles from './slider.module.css';

export enum NavigationTypes {
  DEFAULT = 'default',
  COMPACT = 'compact',
}

export const NavigationButtons: FC<{
  navigation: NavigationOptions;
  type: NavigationTypes;
  classes: {
    container?: string;
    prev?: string;
    next?: string;
  };
}> = ({ navigation, type, classes }) => {
  if (!navigation?.enabled) {
    return null;
  }

  switch (type) {
    case NavigationTypes.COMPACT:
      return (
        <div
          className={clsx(styles.compactNavigationContainer, classes.container)}
        >
          <IconSVG
            type="arrowLongLeft"
            className={clsx(styles.prevCompact, 'slide-prev', classes.prev)}
          />
          <IconSVG
            type="arrowLongRight"
            className={clsx(styles.nextCompact, 'slide-next', classes.next)}
          />
        </div>
      );
    default:
      return (
        !navigation?.prevEl &&
        !navigation?.nextEl && (
          <>
            <IconSVG
              type="arrowVerticalLeft"
              className={clsx(styles.prev, 'slide-prev', classes.prev)}
            />
            <IconSVG
              type="arrowVerticalRight"
              className={clsx(styles.next, 'slide-next', classes.next)}
            />
          </>
        )
      );
  }
};
